exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-078f8367] {\n  margin-top:1.25rem;\n  padding-top:0.5rem;\n  padding-bottom:1rem;\n  padding-left:1rem;\n  padding-right:1rem;\n  border-width:1px\n}\n.item.current[data-v-078f8367] {\n  border-width:1px;\n  border-style:solid;\n  border-color:#00e1ba;\n  border-width:6px\n}\nli[data-v-078f8367] {\n  font-size:1.125rem\n}\n.badge[data-v-078f8367] {\n  display:none;\n}\n.current .badge[data-v-078f8367] {\n  display: block;\n  position: absolute;\n  right: 1rem;\n  top: -1rem;\n  text-transform: uppercase;\n  background: black;\n  padding: 0 0.5rem;\n  color: white;\n}\n", ""]);

// exports
